//
//
//
//
import echarts from 'echarts';
import { debounce } from '@/utils';
export default {
  props: ['chartData'],
  data: function data() {
    return {
      chart: null
    };
  },
  watch: {
    chartData: {
      deep: true,
      handler: function handler(val) {
        this.initChart();
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.initChart();
    this.__resizeHanlder = debounce(function () {
      if (_this.chart) {
        _this.chart.resize();
      }
    }, 100);
    window.addEventListener('resize', this.__resizeHanlder);
  },
  beforeDestroy: function beforeDestroy() {
    if (!this.chart) {
      return;
    }

    window.removeEventListener('resize', this.__resizeHanlder);
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    setOptions: function setOptions(chartData) {
      var value = chartData; //const rate = Math.round(value * 100 / 100);

      var rate = chartData;
      var option = {
        backgroundColor: 'rgba(6, 26, 53)',
        //设置背景颜色
        title: [{
          text: "{a|" + rate + "%}",
          show: true,
          x: "center",
          y: "55%",
          textStyle: {
            rich: {
              a: {
                fontSize: 20,
                color: "#0b98ff",
                fontWeight: "bold"
              }
            }
          }
        }, {
          text: '好评率',
          x: "center",
          y: "25%",
          borderColor: "#fff",
          textStyle: {
            fontWeight: "normal",
            fontSize: 20,
            color: "#fff"
          }
        }],
        polar: {
          center: ["50%", "50%"],
          radius: ["100%", "85%"]
        },
        angleAxis: {
          max: 100,
          show: false
        },
        radiusAxis: {
          type: "category",
          show: true,
          axisLabel: {
            show: false
          },
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          }
        },
        series: [{
          data: [value],
          name: "",
          type: "bar",
          roundCap: true,
          showBackground: true,
          backgroundStyle: {
            color: "rgba(19, 84, 146, .4)"
          },
          coordinateSystem: "polar",
          itemStyle: {
            normal: {
              borderWidth: 0.5,
              shadowBlur: 5,
              borderColor: '#4bf3f9',
              shadowColor: '#9bfeff',
              // color: { // 圆环的颜色
              //   colorStops: [{
              //     offset: 0,
              //     color: '#15caff', // 0% 处的颜色
              //   }, {
              //     offset: 1,
              //     color: '#159bfe', // 100% 处的颜色
              //   }]
              // },
              color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                offset: 0,
                color: "#005DCF"
              }, {
                offset: 1,
                color: "#00CCFF"
              }])
            }
          }
        }]
      };
      this.chart.setOption(option);
    },
    initChart: function initChart() {
      this.chart = echarts.init(this.$refs.myEchart, 'macarons');
      this.setOptions(this.chartData);
    }
  }
};